import { render, staticRenderFns } from "./frontBackaAppraisal_tea.vue?vue&type=template&id=a477804e&scoped=true&"
import script from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
export * from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
import style0 from "./frontBackaAppraisal_tea.vue?vue&type=style&index=0&id=a477804e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a477804e",
  null
  
)

export default component.exports